<?php

Namespace Model\JobList;

use ISOPHP\core;

class PageModel extends \Model\Base
{

    public function getPage($pageVars)
    {
        $page = array();
        $page['title'] = 'Job List of Video Interviews';
        $page['heading'] = 'List of Jobs';
        $page['user_logged'] = $pageVars['params']['user_logged'];
        \ISOPHP\js_core::$console->log('JobList Mod', $page, $pageVars);
        return $page;
    }

    public function showJobList($pageVars)
    {
        return function () use ($pageVars) {
            \ISOPHP\js_core::$console->log('Showing Job List');
            $vars['control'] = 'Job';
            $vars['action'] = 'list';

            $vars['api_uri'] = '/api/jobs/all';

            $afterwards = $this->applyJobListResult($pageVars);
            $result = $this->performRequest($vars, $afterwards, true);
            \ISOPHP\js_core::$console->log('JobList Model: ', $result);
            return $result;
        };
    }

    public function applyJobListResult($pageVars)
    {
        $func = function ($request_data) use ($pageVars) {
            \ISOPHP\js_core::$console->log('applying our Job List result to', $request_data);
            if ($request_data['status'] === 'OK') {
                $vars = array();
                $vars['params'] = $pageVars['params'];
                $vars['request_data'] = $request_data;
                \ISOPHP\js_core::$console->log('apply Job List 1', $vars);
                $view = new \View\JobListView();
                $view->loadTemplate('JobList', 'AllJobs.php', $vars);
                $bind = self::bindButtons();
                $view->displayJobs($bind);
                \ISOPHP\js_core::$console->log('apply Job List 2', $vars);
            }
            if ($request_data['status'] !== 'OK') {
                \ISOPHP\js_core::$console->log('Job List failed');
            }
        };
        return $func;
    }

    /* Show user a list of jobs posted */
    public function showJobListToUser($pageVars)
    {
        return function () use ($pageVars) {
            \ISOPHP\js_core::$console->log('Showing Job List To User');
            $vars['control'] = 'Job';
            $vars['action'] = 'list';

            $vars['api_uri'] = '/api/jobs/all';

            $user_logged = \ISOPHP\core::$registry->getValue('user_logged')['user'];
            \ISOPHP\js_core::$console->log('Logged user at Job List: ', $user_logged);
            $vars['user_id'] = isset($user_logged['id']) ? $user_logged['id'] : '';
            $afterwards = $this->applyJobListToUserResult($pageVars);
            $result = $this->performRequest($vars, $afterwards, true);
            \ISOPHP\js_core::$console->log('JobList Model: ', $result);
            return $result;
        };
    }

    public function applyJobListToUserResult($pageVars)
    {
        $func = function ($request_data) use ($pageVars) {
            \ISOPHP\js_core::$console->log('applying our Job List result to', $request_data);
            if ($request_data['status'] === 'OK') {
                $vars = array();
                $vars['params'] = $pageVars['params'];
                $vars['request_data'] = $request_data;
                \ISOPHP\js_core::$console->log('apply Job List 1', $vars);
                $view = new \View\JobListView();
                $view->loadTemplate('JobList', 'AllJobsForUser.php', $vars);
                $bind = self::bindButtons();
                $view->displayJobs($bind);
                \ISOPHP\js_core::$console->log('apply Job List 2', $vars);
            }
            if ($request_data['status'] !== 'OK') {
                $msg = $request_data['message'];
                \Core\WindowMessage::showMessage($msg, 'bad');
                \ISOPHP\js_core::$console->log('Job List failed');
            }
        };
        return $func;
    }

    /* Show user their Favorite Jobs in a list */
    public function showFavoriteListToUser($pageVars)
    {
        return function () use ($pageVars) {
            \ISOPHP\js_core::$console->log('Showing Favorite List To User');
            $vars['control'] = 'Favorite';
            $vars['action'] = 'list';

            $vars['api_uri'] = '/api/jobs-favorite/all';

            $user_logged = \ISOPHP\core::$registry->getValue('user_logged')['user'];
            \ISOPHP\js_core::$console->log('Logged user at Favorite List: ', $user_logged);
            $vars['user_id'] = isset($user_logged['id']) ? $user_logged['id'] : '';
            $afterwards = $this->applyFavoriteListToUserResult($pageVars);
            $result = $this->performRequest($vars, $afterwards, true);
            \ISOPHP\js_core::$console->log('FavoriteList Model: ', $result);
            return $result;
        };
    }

    public function applyFavoriteListToUserResult($pageVars)
    {
        $func = function ($request_data) use ($pageVars) {
            \ISOPHP\js_core::$console->log('applying our Job List result to', $request_data);
            if ($request_data['status'] === 'OK') {
                $vars = array();
                $vars['params'] = $pageVars['params'];
                $vars['request_data'] = $request_data;
                \ISOPHP\js_core::$console->log('apply Job List 1', $vars);
                $view = new \View\JobListView();
                $view->loadTemplate('JobList', 'AllJobsForUser.php', $vars);
                $bind = self::bindButtons();
                $view->displayJobs($bind);
                \ISOPHP\js_core::$console->log('apply Job List 2', $vars);
            }
            if ($request_data['status'] !== 'OK') {
                $msg = $request_data['message'];
                \Core\WindowMessage::showMessage($msg, 'bad');
                \ISOPHP\js_core::$console->log('Favorite Job List failed');
            }
        };
        return $func;
    }

    /* Show user applied jobs list */
    public function showAppliedListToUser($pageVars)
    {
        return function () use ($pageVars) {
            \ISOPHP\js_core::$console->log('Showing Applied Job List To User');
            $vars['control'] = 'Applied';
            $vars['action'] = 'list';

            $vars['api_uri'] = '/api/jobs-apply/all';

            $user_logged = \ISOPHP\core::$registry->getValue('user_logged')['user'];
            \ISOPHP\js_core::$console->log('Logged user at Applied List: ', $user_logged);
            $vars['user_id'] = isset($user_logged['id']) ? $user_logged['id'] : '';

            $afterwards = $this->applyAppliedListToUserResult($pageVars);
            $result = $this->performRequest($vars, $afterwards, true);
            \ISOPHP\js_core::$console->log('AppliedList Model: ', $result);
            return $result;
        };
    }

    public function applyAppliedListToUserResult($pageVars)
    {
        $func = function ($request_data) use ($pageVars) {
            \ISOPHP\js_core::$console->log('applying our Job List result to', $request_data);
            if ($request_data['status'] === 'OK') {
                $vars = array();
                $vars['params'] = $pageVars['params'];
                $vars['request_data'] = $request_data;
                \ISOPHP\js_core::$console->log('apply Job List 1', $vars);
                $view = new \View\JobListView();
                $view->loadTemplate('JobList', 'AllJobsForUser.php', $vars);
                $bind = self::bindButtons();
                $view->displayJobs($bind);
                \ISOPHP\js_core::$console->log('apply Job List 2', $vars);
            }
            if ($request_data['status'] !== 'OK') {
                $msg = $request_data['message'];
                \Core\WindowMessage::showMessage($msg, 'bad');
                \ISOPHP\js_core::$console->log('Applied Job List failed');
            }
        };
        return $func;
    }

    public function showJobDetails($pageVars)
    {
        return function () use ($pageVars) {
            \ISOPHP\js_core::$console->log('Showing Job List');
            $vars['control'] = 'Job';
            $vars['action'] = 'details';
            $vars['job_id'] = $pageVars['params']['job_id'];
            $vars['api_uri'] = '/api/jobs/' . $vars['job_id'];

            $afterwards = $this->applyJobDetailsResult($pageVars);
            $result = $this->performRequest($vars, $afterwards, true);
            \ISOPHP\js_core::$console->log('JobList Model: ', $result);
            return $result;
        };
    }

    public function applyJobDetailsResult($pageVars)
    {
        $func = function ($request_data) use ($pageVars) {
            \ISOPHP\js_core::$console->log('applying our Job List result to', $request_data);
            if ($request_data['status'] === 'OK') {
                $vars = array();
                $vars['params'] = $pageVars['params'];
                $vars['request_data'] = $request_data;
                \ISOPHP\js_core::$console->log('apply Job List 1', $vars);
                $view = new \View\JobListView();
                $view->loadTemplate('JobList', 'JobDetails.php', $vars);
                $bind = self::bindButtons();
                $view->displayJobs($bind);
                \ISOPHP\js_core::$console->log('apply Job List 2', $vars);
            }
            if ($request_data['status'] !== 'OK') {
                \ISOPHP\js_core::$console->log('Job Detail loading failed');
            }
        };
        return $func;
    }

    public function showEmployerDetails($pageVars)
    {
        return function () use ($pageVars) {
            \ISOPHP\js_core::$console->log('Showing Employer Details');
            $vars['control'] = 'Employer';
            $vars['action'] = 'details';
            $vars['employer_id'] = $pageVars['params']['employer_id'];

            $vars['api_uri'] = '/api/emp-details/' . $vars['employer_id'];

            $afterwards = $this->applyEmployerDetailsResult($pageVars);
            $result = $this->performRequest($vars, $afterwards, true);
            \ISOPHP\js_core::$console->log('showEmployerDetails: ', $result);
            return $result;
        };
    }

    public function applyEmployerDetailsResult($pageVars)
    {
        $func = function ($request_data) use ($pageVars) {
            if ($request_data['status'] === 'OK') {
                $vars = array();
                $vars['params'] = $pageVars['params'];
                $vars['request_data'] = $request_data;
                $view = new \View\JobListView();
                $view->loadTemplate('JobList', 'EmployerDetails.php', $vars);
                $bind = self::bindButtons();
                $view->displayJobs($bind);
                \ISOPHP\js_core::$console->log('applyEmployerDetailsResult');
            }
            if ($request_data['status'] !== 'OK') {
                \ISOPHP\js_core::$console->log('Employer Detail loading failed');
            }
        };
        return $func;
    }

    public function showLastLogin($pageVars)
    {
        return function () use ($pageVars) {

            \ISOPHP\js_core::$console->log('Showing Last Login');
            $user_logged = \ISOPHP\core::$registry->getValue('user_logged')['user'];
            \ISOPHP\js_core::$console->log('Logged user at home summary: ', $user_logged);
            $last_login = $user_logged['last_login'];
            $jQuery = \ISOPHP\js_core::$jQuery;
            $login_date = \ISOPHP\core::$php->date('l, d/m/Y', $last_login);
            $login_time = \ISOPHP\core::$php->date('H:i:s', $last_login);
            $jQuery('#latest-login-date')->html($login_date);
            $jQuery('#latest-login-time')->html($login_time);

//            \ISOPHP\js_core::$console->log('HomeSummary Account Model: ') ;
            return true;
        };
    }

    /**
     * Add job to favorite
     */
    public function addToFavorite($pageVars)
    {
        \ISOPHP\js_core::$console->log('add to favorite');
        $vars = array();
        $vars['control'] = 'Job';
        $vars['action'] = 'favorite';

        $vars['api_uri'] = '/api/jobs-favorite';

        $vars['job_id'] = $pageVars['params']['job_id'];
        $user_logged = \ISOPHP\core::$registry->getValue('user_logged')['user'];
        $vars['user_id'] = isset($user_logged['id']) ? $user_logged['id'] : '';

        $afterwards = $this->applySaveFavoriteResult($pageVars);
        $result = $this->performRequest($vars, $afterwards);
        // \ISOPHP\js_core::$console->log('showEmployerDetails: ', $result);
        return $result;
    }

    public function applySaveFavoriteResult($pageVars)
    {
        $jQuery = \ISOPHP\js_core::$jQuery;
        $func = function ($request_data) use ($jQuery, $pageVars) {
            $selector_id = $pageVars['params']['job_id'];
            \ISOPHP\js_core::$console->log('applying our Save Favorite result to', $request_data);
            if ($request_data['status'] === 'OK') {
                $msg = $request_data['message'];
                // $jQuery('#jobsection_' . $selector_id)->remove();
                $jQuery('#'.$selector_id)->attr('class', 'remove_favorite');
                $jQuery('#'.$selector_id)->children()->attr('class', 'fa fa-heart');
                \Core\WindowMessage::showMessage($msg, 'good');
                \ISOPHP\js_core::$console->log('Favorite saved, data: ', $msg);
            }
            if ($request_data['status'] !== 'OK') {
                $msg = $request_data['message'];
                \Core\WindowMessage::showMessage($msg, 'bad');
                \ISOPHP\js_core::$console->log('favorite failed');
            }
        };
        return $func;
    }

    /**
     * Remove job from favorite
     */
    public function removeFromFavorite($pageVars)
    {
        \ISOPHP\js_core::$console->log('remove from favorite');
        $vars = array();
        $vars['control'] = 'Job';
        $vars['action'] = 'remove_favorite';

        $vars['api_uri'] = '/api/jobs-favorite-remove';


        $vars['job_id'] = $pageVars['params']['job_id'];
        $user_logged = \ISOPHP\core::$registry->getValue('user_logged')['user'];
        $vars['user_id'] = isset($user_logged['id']) ? $user_logged['id'] : '';

        $afterwards = $this->applyRemoveFavoriteResult($pageVars);
        $result = $this->performRequest($vars, $afterwards);
        // \ISOPHP\js_core::$console->log('showEmployerDetails: ', $result);
        return $result;
    }

    public function applyRemoveFavoriteResult($pageVars)
    {
        $jQuery = \ISOPHP\js_core::$jQuery;
        $func = function ($request_data) use ($jQuery, $pageVars) {
            $selector_id = $pageVars['params']['job_id'];
            \ISOPHP\js_core::$console->log('applying our Remove Favorite result to', $request_data);
            if ($request_data['status'] === 'OK') {
                $msg = $request_data['message'];
                $jQuery('#jobsection_' . $selector_id)->remove();
                // $jQuery('#'.$selector_id)->attr('class', 'add_favorite');
                // $jQuery('#'.$selector_id)->children()->attr('class', 'fa fa-heart-o');
                \Core\WindowMessage::showMessage($msg, 'good');
                \ISOPHP\js_core::$console->log('Favorite removed, data: ', $request_data);
            }
            if ($request_data['status'] !== 'OK') {
                $msg = $request_data['message'];
                \Core\WindowMessage::showMessage($msg, 'bad');
                \ISOPHP\js_core::$console->log('remove favorite failed');
            }
        };
        return $func;
    }

    public function showPostNewJob($pageVars)
    {
        return function () use ($pageVars) {
            $view = new \View\JobListView();
            $view->loadTemplate('JobList', 'JobNewPost.php', $pageVars);
            $bind = self::bindButtons();
            $view->displayJobNewPost($bind);
            \ISOPHP\js_core::$console->log("View Here 111111", $view);
            return $view;
        };

    }

    public function savePostNewJob($pageVars)
    {
        $vars['control'] = 'Job';
        $vars['action'] = 'save-job-data';
        $vars['api_uri'] = '/api/jobs-create';


        $jQuery = \ISOPHP\js_core::$jQuery;
        $pHp = \ISOPHP\core::$php;
        $user = \ISOPHP\core::$registry->getValue('user_logged')['user'];
        $vars['user_id'] = $user['id'];

        # Jobs Data
        $vars['title'] = $jQuery->trim($jQuery('#job_tilte')->val());
        $vars['description'] = $jQuery->trim($jQuery('#description')->val());
        $vars['level'] = $jQuery('#level')->val();
        $vars['type'] = $jQuery('#type')->val();
        $vars['location'] = $jQuery->trim($jQuery('#location')->val());
        $vars['role_id'] = $jQuery('#role_type')->val();

        # additional data

        \ISOPHP\js_core::$console->log("Form Validation ignored. here");

        $form_valid = $this->validateJobForm();

        if ($form_valid !== true) {
            $message = 'Invalid Employer Form';
            \Core\WindowMessage::showMessage($message, 'bad');
            return false;
        }
        if ($form_valid === true) {
            $message = 'Valid Employer Form - Trying now...';
            \Core\WindowMessage::showMessage($message, 'good');
            #return true;
        }
        $afterwards = $this->applySaveJobResult($pageVars);
        $result = $this->performRequest($vars, $afterwards);
        return $result;
    }

    public function savePostEditJob($pageVars)
    {
        $vars['control'] = 'Job';
        $vars['action'] = 'edit-job-data';

        $vars['api_uri'] = '/api/jobs-edit';


        $jQuery = \ISOPHP\js_core::$jQuery;
        $pHp = \ISOPHP\core::$php;
        $user = \ISOPHP\core::$registry->getValue('user_logged')['user'];
        $vars['user_id'] = $user['id'];
        $vars['job_id'] = $jQuery('#job_id')->val();

        # Jobs Data
        $vars['title'] = $jQuery->trim($jQuery('#job_tilte')->val());
        $vars['description'] = $jQuery->trim($jQuery('#description')->val());
        $vars['level'] = $jQuery('#level')->val();
        $vars['type'] = $jQuery('#type')->val();
        $vars['location'] = $jQuery->trim($jQuery('#location')->val());
        $vars['contact_person'] = $jQuery->trim($jQuery('#contact_person')->val());
        $vars['role_id'] = $jQuery('#role_type')->val();

        # additional data

        \ISOPHP\js_core::$console->log("Form Validation ignored. here");

        $form_valid = $this->validateJobForm();

        if ($form_valid !== true) {
            $message = 'Invalid Employer Form';
            \Core\WindowMessage::showMessage($message, 'bad');
            return false;
        }
        if ($form_valid === true) {
            $message = 'Valid Employer Form - Trying now...';
            \Core\WindowMessage::showMessage($message, 'good');
            #return true;
        }
        $afterwards = $this->applySaveJobResult($pageVars);
        $result = $this->performRequest($vars, $afterwards);
        return $result;
    }

    public function validateJobForm()
    {

        $jQuery = \ISOPHP\js_core::$jQuery;
        $vars = array();
        $vars['title'] = $jQuery->trim($jQuery('#job_tilte')->val());
        $vars['description'] = $jQuery->trim($jQuery('#description')->val());
        $vars['location'] = $jQuery->trim($jQuery('#location')->val());

        $title_length = \ISOPHP\core::$php->strlen($vars['title']);

        if ($title_length < 3) {
            $error_message = 'Title field must be at least 3 characters';
            \Core\WindowMessage::showMessage($error_message, 'bad');
            return false;
        }

        $description = \ISOPHP\core::$php->strlen($vars['description']);
        if ($description <= 100) {
            $error_message = 'Description field must be at least 100 characters';
            \Core\WindowMessage::showMessage($error_message, 'bad');
            return false;
        }

        $address = \ISOPHP\core::$php->strlen($vars['location']);
        if ($address < 4) {
            $error_message = 'Job location field must be at least 3 characters';
            \Core\WindowMessage::showMessage($error_message, 'bad');
            return false;
        }

        return true;

    }

    public function applySaveJobResult($pageVars)
    {
        $func = function ($request_data) use ($pageVars) {
            if ($request_data['status'] === 'OK') {
                $welcome_message = "Successfully saved";
                \Core\WindowMessage::showMessage($welcome_message, 'good');
            } else if ($request_data['status'] !== 'OK') {
                $welcome_message = "Something went wrong!";
                \Core\WindowMessage::showMessage($welcome_message, 'bad');
            }
        };
        return $func;
    }

    public function showMyPostJob($pageVars)
    {
        return function () use ($pageVars) {

            \ISOPHP\js_core::$console->log('Showing Job List');
            $vars['control'] = 'Job';
            $vars['action'] = 'my_post_jobs';
            $vars['api_uri'] = '/api/jobs-my-jobs';

            $user = \ISOPHP\core::$registry->getValue('user_logged')['user'];
            $vars['user_id'] = $user['id'];
            $afterwards = $this->applyMyJobListResult($pageVars);
            $result = $this->performRequest($vars, $afterwards, true);
            \ISOPHP\js_core::$console->log('JobList Model: ', $result);
            return $result;
        };

    }


    public function applyMyJobListResult($pageVars)
    {
        $func = function ($request_data) use ($pageVars) {
            if ($request_data['status'] === 'OK') {
                $vars = array();
                $vars['params'] = $pageVars['params'];
                $vars['request_data'] = $request_data;
                $view = new \View\JobListView();
                $view->loadTemplate('JobList', 'MyJobs.php', $vars);
                $bind = self::bindButtons();
                $view->displayJobs($bind);
            }
            if ($request_data['status'] !== 'OK') {
                \ISOPHP\js_core::$console->log('Job List failed');
            }
        };
        return $func;
    }

    public function showEditJob($pageVars)
    {
        return function () use ($pageVars) {
            \ISOPHP\js_core::$console->log('Showing Edit form');
            $vars['control'] = 'Job';
            $vars['action'] = 'edit_job';
            $vars['job_id'] = $pageVars['params']['job_id'];
            $vars['api_uri'] = '/api/jobs/' . $vars['job_id'];

            $afterwards = $this->applyJobEditResult($pageVars);
            $result = $this->performRequest($vars, $afterwards, true);
            return $result;
        };
    }

    public function applyJobEditResult($pageVars)
    {
        $func = function ($request_data) use ($pageVars) {
            if ($request_data['status'] === 'OK') {
                $vars = array();
                $vars['params'] = $pageVars['params'];
                $vars['request_data'] = $request_data;
                $view = new \View\JobListView();
                $view->loadTemplate('JobList', 'JobEditPost.php', $vars);
                $bind = self::bindButtons();
                $view->displayJobs($bind);
            }
            if ($request_data['status'] !== 'OK') {
                \ISOPHP\js_core::$console->log('Job List failed');
            }
        };
        return $func;
    }

    /**
     * Apply to a job
     */
    public function applyToJob($pageVars)
    {        
        \ISOPHP\js_core::$console->log('apply to job');
        $vars = array() ;
        $vars['control'] = 'Job';
        $vars['action'] = 'apply';

        $vars['api_uri'] = '/api/jobs-apply';

        $vars['job_id'] = $pageVars['params']['job_id'];
        $user_logged = \ISOPHP\core::$registry->getValue('user_logged')['user'];
        $vars['user_id'] = isset($user_logged['id']) ? $user_logged['id'] : '';

        $afterwards = $this->applySaveAppliedResult($pageVars);
        $result = $this->performRequest($vars, $afterwards);
        // \ISOPHP\js_core::$console->log('showEmployerDetails: ', $result);
        return $result;
    }

    public function applySaveAppliedResult($pageVars)
    {
        $jQuery = \ISOPHP\js_core::$jQuery;
        $func = function ($request_data) use ($jQuery, $pageVars) {
            $selector_id = $pageVars['params']['job_id'];
            \ISOPHP\js_core::$console->log('applying our Save job-applied result to', $request_data);
            if ($request_data['status'] === 'OK') {
                $msg = $request_data['message'];
                $jQuery('#apply_'.$selector_id)->html('<i class="fa fa-thumbs-up"></i></i>')
                                                ->attr('class', 'applied')
                                                ->attr('title', 'Already applied')
                                                ->unbind();
                \Core\WindowMessage::showMessage($msg, 'good');
                \ISOPHP\js_core::$console->log('Apply job saved, data: ', $request_data);
            }
            if ($request_data['status'] !== 'OK') {
                $msg = $request_data['message'];
                \Core\WindowMessage::showMessage($msg, 'bad');
                \ISOPHP\js_core::$console->log('Apply job failed');
            }
        };
        return $func;
    }

    /**
     * Show applicant's profile
     */
    public function showApplicantProfile($pageVars)
    {
        \ISOPHP\js_core::$console->log('show applicant profile');
        $vars = array() ;
        $vars['control'] = 'Candidate';
        $vars['action'] = 'profile';

        $vars['user_id'] = (int) $pageVars['params']['user_id'];
        $vars['api_uri'] = '/api/applicant-profile/' . $vars['user_id'];
        
        // $user_logged = \ISOPHP\core::$registry->getValue('user_logged')['user'];
        // $vars['user_id'] = isset($user_logged['id']) ? $user_logged['id'] : '';

        $afterwards = $this->applyApplicantProfileResult($pageVars);
        $result = $this->performRequest($vars, $afterwards);
        // \ISOPHP\js_core::$console->log('showEmployerDetails: ', $result);
        return $result;
    }

    public function applyApplicantProfileResult($pageVars)
    {
        $jQuery = \ISOPHP\js_core::$jQuery;
        $func = function ($request_data) use ($jQuery, $pageVars) {
            // $selector_id = $pageVars['params']['user_id'];
            //\ISOPHP\js_core::$console->log('applying our fetched applicant profile result to', $request_data);
            if ($request_data['status'] === 'OK') {
                $msg = $request_data['message'];
                $data = $request_data['data'];

                /* dump data into html */                
                $profile_interview_video_html = '';
                if(isset($data['files']['interview_video'])){
                    foreach ($data['files']['interview_video'] as $href) {
                        $profile_interview_video_html .= '<a target="_blank" href="'. $href .'">Click to see/download</a>, ';
                    }
                }
                $profile_interview_video_html = $profile_interview_video_html != '' ? $profile_interview_video_html : 'N/A';
                $profile_cv_html = isset($data['files']['resume_file']) ? '<a target="_blank" href="'. $data['files']['resume_file'][0] .'">Click to see/download</a>' : 'N/A';
                $profile_image_html = isset($data['files']['profile_photo']) ? '<img width="64" height="64" src="'. $data['files']['profile_photo'][0] .'" />' : 'N/A';
                $profile_skills = '';
                foreach($data['skills'] as $skill){
                    $profile_skills .= '<span class="btn btn-primary">' . $skill['skill_details']['skill_name'] . '</span>&nbsp;';
                }
                $profile_certs = '';
                foreach($data['certificates'] as $cert){
                    $profile_certs .= '<span class="btn btn-primary">' . $cert['content'] . '</span>&nbsp;';
                }
                $profile_edus = '';
                foreach($data['educations'] as $edu){
                    $profile_edus .= '<div class="card-body border rounded">';
                    $profile_edus .= '<label>Degree:</label><p class="card-title">' . $edu['content'] . '</p>';
                    $profile_edus .= '<label>Institution:</label><p class="card-title">' . $edu['institution'] . '</p>';
                    $profile_edus .= '<label>Passing Year:</label><p class="card-title">' . $edu['pass_year'] . '</p>';
                    $profile_edus .= '</div>';
                }
                $profile_html = '
                <div class="col-md-12">
                    <div class="row">
                        <div class="col-md-8">
                            <div><label>Name:</label> '. $data['full_name'] .'</div>
                            <div><label>Email:</label> '. $data['email'] .'</div>
                            <div><label>Phone:</label> '.  $data['candidate']['phone_number'] .'</div>
                        </div>
                        <div class="col-md-4">
                            '. $profile_image_html .'
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <div><label>Address:</label> '. $data['candidate']['address'] .'</div>
                            <div><label>DOB:</label> '. $data['candidate']['date_of_birth'] .'</div>
                            <div><label>Gender:</label> '. $data['candidate']['gender'] .'</div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <div><label>Resume/CV:</label> '. $profile_cv_html .' </div>
                        </div>
                        <div class="col-md-12">
                            <div><label>Skills:</label> '. $profile_skills .' </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <div><label>Certificates:</label> '. $profile_certs .' </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <div><label>Educations:</label> <div class="row">'. $profile_edus .' </div></div>
                        </div>
                    </div>
                </div>';

                // $data = $request_data['dataHtml'];
                \Core\WindowMessage::showOverlay($msg, $profile_html); 
            }
            if ($request_data['status'] !== 'OK') {
                $msg = $request_data['message'];
                \Core\WindowMessage::showMessage($msg, 'bad');
                \ISOPHP\js_core::$console->log('Applicant profile not found!');
            }
        };
        return $func;
    }

    /**
     * Invite applicant for interview
     */
    public function inviteForInterview($pageVars)
    {
        \ISOPHP\js_core::$console->log('show applicant profile');
        $vars = array() ;
        $vars['control'] = 'Candidate';
        $vars['action'] = 'profile';

        $vars['job_id'] = (int) $pageVars['params']['job_id'];
        $vars['api_uri'] = '/api/jobs/' . $vars['job_id'];
        
        // $user_logged = \ISOPHP\core::$registry->getValue('user_logged')['user'];
        // $vars['user_id'] = isset($user_logged['id']) ? $user_logged['id'] : '';

        $afterwards = $this->applyInviteForInterviewResult($pageVars);
        $result = $this->performRequest($vars, $afterwards);
        // \ISOPHP\js_core::$console->log('showEmployerDetails: ', $result);
        return $result;
    }

    public function applyInviteForInterviewResult($pageVars)
    {
        $jQuery = \ISOPHP\js_core::$jQuery;
        $yesAction = $this->sendInvitationSchedule($pageVars);
        $func = function ($request_data) use ($jQuery, $pageVars, $yesAction) {
            // $selector_id = $pageVars['params']['user_id'];
            //\ISOPHP\js_core::$console->log('applying our fetched applicant profile result to', $request_data);
            if ($request_data['status'] === 'OK') {
                $title = 'Interview Invitation';
                $data = $request_data['data'];
                
                $applicantsOptions='';
                if(!empty($data['applied'])){
                    foreach ($data['applied'] as $applicant) {
                        $applicantsOptions .= '<option value="'. $applicant['appliedinfo']['id'] .'">'. $applicant['appliedinfo']['full_name'] .'</option>';
                    }
                }

                $context = '
                <div class="col-md-12">                    
                    <div class="row">
                        <div class="col-md-12">
                            <div><label>Job Title:</label> '. $data['title'] .'</div>
                            <div><label>Applicants<i>'. $data['applied_count'] .'</i> :</label>  
                            <select id="candidates_selected" class="form-control applicant_multiselect" multiple required>
                            '. $applicantsOptions .'
                            </select> </div>
                            <div><label>Date:</label> <input type="date" name="interview_at_date" id="candidate_interview_at_date" class="form-control" required /></div>
                            <div><label>Time:</label> <input type="time" name="interview_at_time" id="candidate_interview_at_time" class="form-control" /></div>
                            <div class="clearfix">&nbsp;</div>
                        </div>
                    </div>
                </div>';

                // $context = $request_data['html'];
                $yes = 'Send';
                $no = 'Cancel';
                \Core\WindowMessage::dialogOverlay($title, $context, $yes, $no, $yesAction); 
               
            } 
            if ($request_data['status'] !== 'OK') {
                $msg = $request_data['message'];
                \Core\WindowMessage::showMessage($msg, 'bad');
                \ISOPHP\js_core::$console->log('Sorry! no applicant found.');
            }
        };
        return $func;
    }
    
    /* Save schedule in db */
    public function sendInvitationSchedule($pageVars)
    {
        return $func = function () use($pageVars){
            $jQuery = \ISOPHP\js_core::$jQuery;
            $vars = [];
            $vars['user_ids'] = \ISOPHP\core::$php->json_encode($jQuery('#candidates_selected')->val());
            $vars['date'] = $jQuery('#candidate_interview_at_date')->val();
            $vars['time'] = $jQuery('#candidate_interview_at_time')->val();

            $vars['job_id'] = (int) $pageVars['params']['job_id'];
            $vars['api_uri'] = '/api/jobs-invite-schedule/' . $vars['job_id'];

            \ISOPHP\js_core::$console->log('form form data :', $var);
            \ISOPHP\js_core::$console->log('form pageVars  :', $pageVars);

            $afterwards = $this->applyInvitationScheduleResult($pageVars);
            $result = $this->performRequest($vars, $afterwards);
            return $result;
        };
        
    }

    public function applyInvitationScheduleResult($pageVars)
    {
        $jQuery = \ISOPHP\js_core::$jQuery;
        $func = function ($request_data) use ($jQuery, $pageVars) {
            if ($request_data['status'] === 'OK') {
                $msg = $request_data['message'];
                \Core\WindowMessage::showMessage($msg, 'good');
            }
            if ($request_data['status'] !== 'OK') {
                $msg = $request_data['message'];
                \Core\WindowMessage::showMessage($msg, 'bad');
                \ISOPHP\js_core::$console->log('Sorry! something went wrong!.');
            }
        };
        return $func;
    }




    public static function bindButtons()
    {
        return function () {
            if (ISOPHP_EXECUTION_ENVIRONMENT === 'UNITER') {
                $navigate = new \Model\Navigate();
                $jQuery = \ISOPHP\js_core::$jQuery;

                $go_landing_page = $jQuery('#go-landing-page');
                $go_landing_page->on('click', function ($jqThis) use ($navigate) {
                    $jqThis->preventDefault();
                    $navigate->route('LandingPage', 'show', array(), '/');
                });

                $go_home_page = $jQuery('.go-home-page');
                $go_home_page->on('click', function ($jqThis) use ($navigate) {
                    $jqThis->preventDefault();
                    $navigate->route('Home', 'show', array(), '/home');
                });

                $go_home_page = $jQuery('.go-jobs-list');
                $go_home_page->on('click', function ($jqThis) use ($navigate) {
                    $jqThis->preventDefault();
                    $navigate->route('JobList', 'show', array(), '/jobslist');
                });

                $jobDetails = $jQuery('.jobs-details');
                $jobDetails->on('click', function ($jqThis) use ($jQuery, $navigate) {
                    $jqThis->preventDefault();
                    $this_id = $jqThis->currentTarget->id;
                    $job_id = \ISOPHP\core::$php->str_replace("job_", "", $this_id);
                    \ISOPHP\js_core::$console->log('going to account', $job_id);
                    $navigate = new \Model\Navigate();
                    $navigate->route('JobList', 'details', array('job_id' => $job_id), '/jobslist/' . $job_id);
                    \ISOPHP\js_core::$console->log('Yes Here Is job details', $job_id);
                });

                $employerDetail = $jQuery('.go-employer-detail');
                $employerDetail->on('click', function ($jqThis) use ($jQuery, $navigate) {
                    $jqThis->preventDefault();
                    $thisId = $jqThis->currentTarget->id;
                    $employerId = \ISOPHP\core::$php->str_replace("employer_", "", $thisId);
                    $navigate = new \Model\Navigate();
                    $navigate->route('JobList', 'profile', array('employer_id' => $employerId), '/employer/' . $employerId);
                    \ISOPHP\js_core::$console->log('Yes Here Is Employer details', $employerId);
                });

                $addFavoriteJobAction = $jQuery('.add_favorite');
                $addFavoriteJobAction->on('click', function ($jqThis) use ($navigate) {
                    $jqThis->preventDefault();
                    $jobId = $jqThis->currentTarget->id;
                    // $model->addToFavorite($jobId);
                    $navigate->route('JobList', 'save-favorite', array('job_id' => $jobId));
                });

                $removeFavoriteJobAction = $jQuery('.remove_favorite');
                $removeFavoriteJobAction->on('click', function ($jqThis) use ($navigate) {
                    $jqThis->preventDefault();
                    $jobId = $jqThis->currentTarget->id;
                    $navigate->route('JobList', 'remove-favorite', array('job_id' => $jobId));
                });

                $post_new_job = $jQuery('#post_new_job');
                $post_new_job->unbind()->bind('click', function ($jqThis) use ($jQuery, $navigate) {
                    $jqThis->preventDefault();
                    \ISOPHP\js_core::$console->log('Your job is succesfully posted');
                    $navigate->route('JobList', 'save-job', array());
                });

                $employerDetail = $jQuery('.go-edit-job');
                $employerDetail->on('click', function ($jqThis) use ($jQuery, $navigate) {
                    $jqThis->preventDefault();
                    $thisId = $jqThis->currentTarget->id;
                    $jobId = \ISOPHP\core::$php->str_replace("job_", "", $thisId);
                    $navigate = new \Model\Navigate();
                    $navigate->route('JobList', 'show-edit-job', array('job_id' => $jobId), '/job/' . $jobId);
                    \ISOPHP\js_core::$console->log('Yes Here Is Employer details', $jobId);
                });

                $post_edit_job = $jQuery('#post_edit_job');
                $post_edit_job->unbind()->bind('click', function ($jqThis) use ($jQuery, $navigate) {
                    $jqThis->preventDefault();
                    \ISOPHP\js_core::$console->log('Your job is succesfully Edit');
                    $navigate->route('JobList', 'edit-job', array());
                });

                $apply_job = $jQuery('.apply_job');
                $apply_job->unbind()->bind('click', function ($jqThis) use ($jQuery, $navigate) {
                    $jqThis->preventDefault();
                    $this_id = $jqThis->currentTarget->id;
                    $job_id = \ISOPHP\core::$php->str_replace("apply_", "", $this_id);
                    \ISOPHP\js_core::$console->log('Clicked apply button');
                    $msg = "You are about to apply this job, which means your Profile, Resume, Skill etc will be visible to the job poster.<br>Are you sure?";
                    $confirmAction = function () use ($navigate, $job_id) {
                        $navigate->route('JobList', 'apply-job', array('job_id' => $job_id));
                    };
                    \Core\WindowMessage::areYouSure($msg, $confirmAction);
                    // $navigate->route('JobList', 'edit-job', array());
                });

                /* Employeer click to see applicant profile data */
                $applicant_profile = $jQuery('.applicant-profile');
                $applicant_profile->unbind()->bind('click', function ($jqThis) use ($jQuery, $navigate) {
                    $jqThis->preventDefault();
                    $this_id = $jqThis->currentTarget->id;
                    $user_id = \ISOPHP\core::$php->str_replace("see_profile_", "", $this_id);
                    \ISOPHP\js_core::$console->log('Clicked see profile button');
                    // $msg = "Applicant Profile";
                    $navigate->route('JobList', 'applicant-profile', array('user_id' => $user_id));
                    // \Core\WindowMessage::showOverlay($msg, $confirmAction);
                });

                /* Employeer click to invite applicant for interview */
                $invite_applicant = $jQuery('.invite_applicant');
                $invite_applicant->unbind()->bind('click', function ($jqThis) use ($jQuery, $navigate) {
                    $jqThis->preventDefault();
                    $job_id = $jqThis->currentTarget->dataset->job_id;
                    // $user_id = \ISOPHP\core::$php->str_replace("see_profile_", "", $this_id);
                    \ISOPHP\js_core::$console->log('Clicked to invite for interview', $job_id);
                    // $title = "Interview Invitation";
                    // $msg = "Interview Invitation";
                    $navigate->route('JobList', 'invitation', array('job_id' => $job_id));
                    // \Core\WindowMessage::showOverlay($title, $msg);
                });


            }
        };
    }


}


// WEBPACK FOOTER //
// app/JobList/Model/JobListPageModel.php